import React, { Component } from "react";

import { css, StyleSheet } from "aphrodite/no-important";

class splitColumn extends Component {
  render() {
    return (
      <div className="container">
        <div
          className="row"
          style={{ margin: "30px auto", maxWidth: this.props.maxWidth }}
        >
          <div
            className={`col-md-6 ${
              this.props.padding ? "pr-" + this.props.padding : ""
            } `}
          >
            <div className="align-items-center">{this.props.left}</div>
          </div>
          <div
            className={`col-md-6 ${
              this.props.padding ? "pl-" + this.props.padding : ""
            } `}
          >
            {this.props.right}
          </div>
        </div>
      </div>
    );
  }
}

export default splitColumn;

const styles = StyleSheet.create({
  left: {
    textAlign: "left",
    color: "#ffffff!important"
  },
  button: {
    marginTop: "10px",
    maxWidth: "150px",
    margin: "10px auto"
  }
});



// WEBPACK FOOTER //
// ./src/sections/layouts/splitColumn.js